import axios from "axios";
import { endpointApi } from "../../utils";
import { logout } from "./auth.action";
import { PACKAGING_LIST_FAIL, PACKAGING_LIST_REQUEST, PACKAGING_LIST_SUCCESS } from "../constats/packaging.constant";

export const getPackagingList = (location=null, navigate=null) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: PACKAGING_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }packagings${ location ? location.search : "" }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: PACKAGING_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: PACKAGING_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: PACKAGING_LIST_FAIL,
                payload: err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}